import Query from '../../../components/Report';

export const query = ({ fromEnd, fromStart, toStart, toEnd }) =>
    new Query('discover-algo-comparison-categories', { fromEnd, fromStart, toStart, toEnd });
